import {
  Navigate,
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router";
import { SidebarLayout } from "./components/shell/sidebar-layout";
import { AuthLayout } from "./components/shell/auth-layout";
import {
  ReportsPage,
  ReportDetailsPage,
  RunReportPage,
} from "@/features/reports";
import { MiniToolsPage } from "@/features/mini-tools";
import {
  LoginPage,
  ResetPasswordPage,
  ResetPasswordConfirmPage,
} from "@/features/auth";
import { AuthGuardLayout } from "@/platform/auth";
import { ProfilePage } from "@/features/profile";
import {
  TemplateOverviewPage,
  TemplateEditorPage,
} from "@/features/template-builder";
import { DashboardPage } from "@/features/dashboard";
import { ResourcesPage, ResourceUploadPage } from "@/features/resources";
import { MatrixPage } from "@/features/matrix";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/reset-password/confirm"
          element={<ResetPasswordConfirmPage />}
        />
      </Route>
      <Route
        path="/"
        element={<SidebarLayout />}
        handle={{ breadcrumb: "Home" }}
      >
        <Route element={<AuthGuardLayout />}>
          <Route index element={<Navigate replace to="/dashboard" />} />
          <Route
            path="dashboard"
            element={<DashboardPage />}
            handle={{ breadcrumb: "Dashboard" }}
          />
          <Route path="reports" handle={{ breadcrumb: "Reports" }}>
            <Route index element={<ReportsPage />} />
            <Route
              path="run"
              element={<RunReportPage />}
              handle={{ breadcrumb: "Run Report" }}
            />
            <Route
              path=":uuid"
              element={<ReportDetailsPage />}
              handle={{ breadcrumb: "Report Details" }}
            />
          </Route>
          <Route path="templates" handle={{ breadcrumb: "Templates" }}>
            <Route index element={<TemplateOverviewPage />} />
            <Route
              path=":uuid"
              element={<TemplateEditorPage />}
              handle={{ breadcrumb: "Template Editor" }}
            />
          </Route>
          <Route
            path="mini-tools"
            element={<MiniToolsPage />}
            handle={{ breadcrumb: "Mini Tools" }}
          />
          <Route
            path="template-builder"
            handle={{ breadcrumb: "Template Builder" }}
          >
            <Route index element={<TemplateOverviewPage />} />
            <Route
              path=":uuid"
              element={<TemplateEditorPage />}
              handle={{ breadcrumb: "Template Editor" }}
            />
          </Route>
          <Route path="matrix" handle={{ breadcrumb: "Matrices" }}>
            <Route index element={<MatrixPage />} />
            <Route path=":collectionId" element={<MatrixPage />} />
          </Route>
          <Route
            path="resources"
            element={<ResourcesPage />}
            handle={{ breadcrumb: "Resources" }}
          />
          <Route
            path="resources/new"
            element={<ResourceUploadPage />}
            handle={{ breadcrumb: "Upload Resource" }}
          />
          <Route
            path="profile"
            element={<ProfilePage />}
            handle={{ breadcrumb: "Profile" }}
          />
        </Route>
      </Route>
    </>,
  ),
);

export const AppRoutes = () => <RouterProvider router={router} />;
